module.exports = class SeparatorBuilder {
    addCodeGenerator() {
        //do nothing
    }

    addToBlocks() {
        //do nothing
    }
    /**
     * @typedef {Object} Toolbox
     * @property {string} kind - The kind of toolbox object.
     * @property {ToolboxCategory[]} contents - The contents of the toolbox object.
     * @typedef {Object} ToolboxCategory
     * @property {string} kind - The kind of toolbox object.
     * @property {string} name - The name of the toolbox object.
     * @property {string} colour - The colour of the toolbox object.
     * @property {Array} contents - The contents of the toolbox object.
     * @typedef {ToolboxBlock[]} ToolboxBlock
     * @property {string} kind - The kind of toolbox object.
     * @property {string} type - The type of the toolbox object.
     */
    addToolboxCategory(toolbox) {
        toolbox.contents.push({ kind: 'sep', gap: '32' });
    }
};
